/**
 * Ordered so sequentially auto-assigned recordings stay easy to tell apart,
 * including for red/green colour-vision deficiency: Red never sits next to
 * Green, and the first four colours are all high-contrast under CVD.
 */
export const RECORDING_COLORS = [
  { value: '#1976d2', label: 'Blue' },
  { value: '#ed6c02', label: 'Orange' },
  { value: '#2e7d32', label: 'Green' },
  { value: '#9c27b0', label: 'Purple' },
  { value: '#0288d1', label: 'Cyan' },
  { value: '#d32f2f', label: 'Red' },
  { value: '#616161', label: 'Grey' },
];

export const DEFAULT_RECORDING_COLOR = RECORDING_COLORS[0].value;

/** The colour for the nth recording added to a workspace, cycling the palette. */
export function colorForIndex(index) {
  return RECORDING_COLORS[index % RECORDING_COLORS.length].value;
}
